import { useEffect } from 'react'
import Lottie from 'react-lottie'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import Column from 'components/Column'
import animationData from 'components/Lottie/tick'
import Footer from 'components/Footer'
import Spacer from 'components/Spacer'
import FadeDiv from 'components/FadeDiv'
import Row from 'components/Row'
import { maskValue } from 'utils/helpers'

import Container from './styles'

export default function Success() {
  const { t } = useTranslation()
  const history = useHistory()
  const info = useSelector((state) => state.info)

  useEffect(() => {
    if (!info.type || info.type === '') {
      history.replace('/')
    }
  }, [history, info.type])

  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  function DbSection({ info }) {
    return (
      <div>
        <p className="description">
          {t('home.database.modal.footer', {
            databases: info.databases,
            hours: info.hours,
          })}
        </p>
        <Spacer height={10} />
        <p className="description_price">
          {t('home.database.modal.footer_price', {
            total: maskValue(info.totalValue),
          })}
        </p>
      </div>
    )
  }

  function HourSection({ info }) {
    return (
      <div>
        <p className="description-hour">
          {t('home.hourly.modal.purchase_info', { hours: info.hours })}
        </p>
        <Spacer height={15} />
        <Row justify="center">
          <div>
            <p className="description_price">
              {t('summary.hours_price', { price: maskValue(info.hoursValue) })}
            </p>
          </div>
        </Row>
      </div>
    )
  }

  return (
    <Container>
      <Column align="center">
        <div className="purchase-success">
          <Lottie options={defaultOptions} height={200} width={200} />
          <FadeDiv initial={40} final={0} delay={0.5} orientation="vertical">
            <p>{t('success.purchase')}</p>
          </FadeDiv>
        </div>

        <FadeDiv initial={40} final={0} delay={1} orientation="vertical">
          <div className="thank-you">
            <p className="thanks">{t('success.thank_you')}</p>
            <p className="soon">{t('success.soon')}</p>
          </div>

          <div className="contacts">
            <Row align="center" justify="center">
              <p>{t('success.contacts')}</p>
              <p>{t('success.phone')}</p>
              <p>{t('success.email')}</p>
            </Row>
          </div>
          <Spacer height={40} />
        </FadeDiv>

        <FadeDiv initial={40} final={0} delay={1.1} orientation="vertical">
          <div className="details">
            <p className="title">{t('success.details')}</p>
            {info.type === 'databases' && <DbSection info={info} />}
            {info.type === 'hours' && <HourSection info={info} />}
          </div>
        </FadeDiv>

        <FadeDiv initial={40} final={0} delay={1.3} orientation="vertical">
          <Spacer height={30} />
          <Footer />
        </FadeDiv>

        <Spacer height={30} />
      </Column>
    </Container>
  )
}
